<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>ZONE<span class="head-btn-style">
                <button *ngIf="!listView"(click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_zone_Save" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="zones" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="zoneColumns" [selectionField]="'Zone_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addZone($event)" (editEntity)="editZone($event)"
            (refreshEntities)="refreshZones($event)" (deleteEntity)="deleteZone($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearZone()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Zone Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'ZoneName'" id="txt_zone_Name" [(ngModel)]="entity.ZoneName"
                         ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'Code'" id="txt_zone_Code" [(ngModel)]="entity.Code"
                    ngDefaultControl></textbox>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone Head'"   [formData]="entity" [data]="employees" [mandatory]="false"
                    [filterable]="true" id="drp_zone_Head"  (filterChanged)="getAllEmployees($event)" [class] = "'form-control'"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" id="drp_zone_Company"  [filterable]="true" (filterChanged)="getAllCompany($event)"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div>
            </div>
            <div class="row"> 
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="false"
                        [fieldName]="'EmailId'"id="txt_zone_Email"   [(ngModel)]="entity.EmailId" ngDefaultControl></textbox> 
                </div> 
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'"
                        [(ngModel)]="entity.Phone" id="txt_zonePhone"  (paste)="onPaste($event)" (keypress)="numberOnly($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div> 
            </div>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" id="btn_zone_Save"  (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div> -->
            </div>
        </div>
  </div>
    </div>
    <ng-template #view let-dataItem let-rowIndex="rowIndex">
        <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
      </ng-template>
      <kendo-dialog title="Zone Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
        <div class="col-md-12 content-area">
            <div class="row">
              <div class="col-md-4 br-table-data">
                <label for="ZoneName" class="label label-1">Zone Name : </label> {{details.ZoneName }}
              </div>
              <div class="col-md-4 br-table-data">
                <label for="Code" class="label label-1">Code : </label> {{details.Code}}
              </div>
              <div class="col-md-4 br-table-data">
                <label for="Zone Head" class="label label-1">Zone Head : </label> {{details.EmployeeName}}
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 br-table-data">
                <label for="Company" class="label label-1">Company : </label>  {{details.CompanyName}}
              </div>
              <div class="col-md-4 br-table-data">
                <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
              </div>
              <div class="col-md-4 br-table-data">
                <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
              </div>
            </div>
            </div>
        </kendo-dialog>
           


<kendo-excelexport [data]="zones.data" [collapsible]="true" fileName="Zone.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ZoneName" title="Zone" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Code" title="Code" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="EmployeeName" title="Zone Head" [width]="200">
    </kendo-excelexport-column>   
    <kendo-excelexport-column field="ZoneMail" title="Email" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ZonePhone" title="Phone" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>